import { AccessibilityPaneComponent } from "./components/accessibility-pane/accessibility-pane.component";
import { AssistantContactFormComponent } from "./components/assistant-contact-form/assistant-contact-form.component";
import { CharacterCounter } from "./components/character-counter/character-counter.component";
import { CountdownTimerComponent } from "./components/countdown-timer/countdown-timer.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";
import { FavouritesControl } from "./components/favourites/favourites-control.service";
import { FavouritesListControlService } from "./components/favourites/favourites-list-control.service";
import { HidePageButton } from "./components/hide-page-button/hide-page-button.component";
import { ImageUploadPreviewComponent } from "./components/image-upload-preview/image-upload-preview.component";
import { MapComponent } from "./components/map/map.component";
import { NavigationBarComponent } from "./components/navigation-bar/navigation-bar.component";
import { NotificationService } from "./components/notification/notification.service";
import { SlickSliderComponent } from "./components/slick-slider/slick-slider.component";
import { SmartSuggestComponent } from "./components/smart-suggest/smart-suggest.component";
import { VideoBoxComponent } from "./components/video-box/video-box.component";

class FrontendModule {
    public init(): void {
        $.extend($, {
            pcg: {
                frontend: {
                    accessibilityPane: AccessibilityPaneComponent,
                    assistantContactForm: AssistantContactFormComponent,
                    characterCounter: CharacterCounter,
                    countdownTimer: CountdownTimerComponent,
                    datePicker: DatePickerComponent,
                    favouritesControl: new FavouritesControl(),
                    favouritesListService: new FavouritesListControlService(),
                    hidePageButton: HidePageButton,
                    imageUploadPreview: ImageUploadPreviewComponent,
                    map: MapComponent,
                    navigationBar: NavigationBarComponent,
                    notificationService: new NotificationService(),
                    slickSlider: SlickSliderComponent,
                    smartSuggest: SmartSuggestComponent,
                    videoBox: VideoBoxComponent
                }
            }
        });
    }
}

export const frontend = new FrontendModule();
